import { useState } from 'react';
import closeDelete from '@/assets/images/closeDelete.svg';
import coinIcon from '@/assets/images/KitoCoin.webp';
import { KITOPI_APP_STORE_CASHBACK_BANNER } from '@/constants/appStores';
import { BUTTON_SOURCES } from '@/constants/buttonSources';
import { useBrowserUserId } from '@/hooks/useBrowserUserId';
import { trackButtonClick } from '@/utils/gtmButtonClicked';
import styles from './CashbackBanner.module.scss';

interface Props {
  floating?: boolean;
  content?: string;
}

export const CashbackBanner = ({
  floating = false,
  content = 'Get cashback when you pay in the app',
}: Props) => {
  const browserUserId = useBrowserUserId();
  const [isVisible, setIsVisible] = useState(() => {
    return sessionStorage.getItem('cashbackBannerClosed') !== 'true';
  });
  const deferredLinkFeatureValue = KITOPI_APP_STORE_CASHBACK_BANNER;

  const handleBannerClick = () => {
    trackButtonClick({
      buttonId: 'cashback-banner-text',
      buttonName: 'cashback-banner-text',
      buttonSource: BUTTON_SOURCES.CASHBACK_BANNER,
      extraParams: {
        browser_user_id: browserUserId,
      },
    });
  };

  const bannerContent = (
    <div className={`${styles.cashbackBanner} ${!isVisible && styles.hidden}`}>
      <img src={coinIcon} alt="Cashback icon" className={styles.coinIcon} />
      <a
        className={styles.bannerText}
        href={deferredLinkFeatureValue}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleBannerClick}
      >
        {content}
      </a>
      <img
        src={closeDelete}
        alt="Close icon"
        className={styles.closeIcon}
        onClick={() => {
          setIsVisible(false);
          sessionStorage.setItem('cashbackBannerClosed', 'true');
        }}
      />
    </div>
  );

  if (floating) {
    return <div className={styles.floatingWrapper}>{bannerContent}</div>;
  }

  return bannerContent;
};
